export const getDefaultValues = (details) => ({
  ApplicationDomainHostName: details?.ApplicationDomainHostName || '',
});
